import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import AppLayout from "../layouts/AppLayout";
import Navigation from "../../components/root/Navigation";
import Footer from "../../components/root/Footer";

export function RequireAuth({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  return children;
}

export function RedirectIfAuthed({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/home" replace />;
  return children;
}

// Renders courses/course pages with the full app shell for logged-in users,
// and an indexable public shell (marketing nav + footer) for guests.
export function CourseShell({ children }) {
  const { user } = useAuth();
  if (user) return <AppLayout>{children}</AppLayout>;
  return (
    <>
      <Navigation />
      {children}
      <Footer />
    </>
  );
}
